import React from 'react'

import { StyledTag } from 'component-library/buttons/Tag/Tag.styled'

import { Topic } from 'common/client-data-types/topic'
import { toTopicRouteHint } from 'common/routing/route-hints'
import { useTheme } from '@emotion/react'

export interface Props {
    topic: Topic
}

export const Tag: React.FC<Props> = ({ topic }) => {
    const { section } = useTheme()
    return (
        // data-section is whitelisted under amp for a tags, needed to use it here as StyledTag wraps a Link
        <StyledTag data-section={section} to={toTopicRouteHint(topic)}>
            {topic.title}
        </StyledTag>
    )
}

Tag.displayName = 'Tag'
